import React from 'react';
import ResCol from 'components/ResCol';
import useCostCenter from 'core/hooks/useCostCenter';
import { FormItemWrap, RemoteSelect } from '@unicus/react-ui-kit';

const RemoteCostCenterFieldSelect = ({
  name = 'costCenter',
  label = 'Centro de custo',
  required = true,
  useRow = true,
  span = 12
}) => {
  const { enabledCostCenter } = useCostCenter();

  if (!enabledCostCenter) {
    return null;
  }

  return useRow ? (
    <ResCol span={span}>
      <FormItemWrap name={name} label={label} required={required}>
        <RemoteSelect resource="cost-centers" />
      </FormItemWrap>
    </ResCol>
  ) : (
    <FormItemWrap name={name} label={label} required={required}>
      <RemoteSelect resource="cost-centers" />
    </FormItemWrap>
  );
};

export default RemoteCostCenterFieldSelect;
